import graphql from "babel-plugin-relay/macro";

export const DeleteMemberUserMutationString = graphql`
  mutation DeleteMemberUser_Mutation {
    responsePayload: deleteMemberUser {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
